export function combineClientStateIdsWithExistingIds(ids, stateIds) {
    if (!ids) ids = [];
    if (!stateIds) stateIds = [];

    return [...ids, ...stateIds].filter((value, index, self) => self.indexOf(value) === index);
}
